// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__KEFzd","loaderOuter":"PageOverlayLoader_loaderOuter__2NNtb"};